import {AttributeTypeEnum} from "../enums/AttributeTypeEnum";

export default function AgHelpToolTip() {
}

AgHelpToolTip.prototype.init = function (params) {
    this.eGui = document.createElement('div');
    this.eGui.classList.add('ag-help-tooltip');
    this.eGui.style.backgroundColor = '#1C1F20'
    this.eGui.style.border = '1px solid #b5b5b5'

    switch (params.colDef.dataType) {
        case AttributeTypeEnum.JSON:
        case AttributeTypeEnum.TEXT:
        case AttributeTypeEnum.LOOKUP:
        case AttributeTypeEnum.INCREMENTING:
            this.eGui.innerHTML = `<table class="ag-grid-rule-tooltip">
                             <tr>
                               <th>EXPR</th>
                               <th>RULE</th>
                             </tr>
                             <tr>
                               <td>phrase</td>
                               <td>STARTS WITH</td>
                             </tr>
                             <tr>
                               <td>!phrase</td>
                               <td>DOES NOT START WITH</td>
                             </tr>
                             <tr>
                               <td>phrase=</td>
                               <td>EQUALS</td>
                             </tr>
                             <tr>
                               <td>!phrase=</td>
                               <td>DOES NOT EQUAL</td>
                             </tr>
                              <tr>
                               <td>=</td>
                               <td>ANY VALUE</td>
                             </tr>
                             <tr>
                               <td>!=</td>
                               <td>NO VALUE</td>
                             </tr>
                             <tr>
                               <td>expr1 expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 & expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 && expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 | expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                             <tr>
                               <td>expr1 || expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                           </table>`;
            break;
        case AttributeTypeEnum.INT:
        case AttributeTypeEnum.DECIMAL:
            this.eGui.innerHTML = `<table class="ag-grid-rule-tooltip">
                             <tr>
                               <th>EXPR</th>
                               <th>RULE</th>
                             </tr>
                             <tr>
                               <td>num=</td>
                               <td>EQUALS</td>
                             </tr>
                             <tr>
                               <td>!num=</td>
                               <td>DOES NOT EQUAL</td>
                             </tr>
                             <tr>
                               <td>&gtnum</td>
                               <td>GREATER THAN</td>
                             </tr>
                             <tr>
                               <td>&ltnum</td>
                               <td>LESS THAN</td>
                             </tr>
                             <tr>
                               <td>expr1 expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 & expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 && expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 | expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                             <tr>
                               <td>expr1 || expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                          </table>`;
            break;
        case AttributeTypeEnum.DATE:
        case AttributeTypeEnum.TIME:
        case AttributeTypeEnum.TIMESTAMP:
            if (params.column.colId === 'stamp') {
                this.eGui.innerHTML = `<table class="ag-grid-rule-tooltip">
                             <tr>
                               <th>EXPR</th>
                               <th>RULE</th>
                             </tr>
                             <tr>
                               <td>'2020-01-01T12:00'</td>
                               <td>EQUALS</td>
                             </tr>
                             <tr>
                               <td>&gt'2020-01-01T12:00'</td>
                               <td>GREATER THAN</td>
                             </tr>
                              <tr>
                               <td>&lt'2020-01-01T12:00'</td>
                               <td>LESS THAN</td>
                             </tr>
                             <tr>
                               <td>'2020-01-01T12:00::2020-01-31T12:00'</td>
                               <td>IN RANGE</td>
                             </tr>
                             <tr>
                               <td>expr1 expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 & expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 && expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 | expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                             <tr>
                               <td>expr1 || expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                           </table>`;
            } else {
                this.eGui.innerHTML = `<table class="ag-grid-rule-tooltip">
                             <tr>
                               <th>EXPR</th>
                               <th>RULE</th>
                             </tr>
                             <tr>
                               <td>&gt'2020-01-01T12:00'</td>
                               <td>GREATER THAN</td>
                             </tr>
                              <tr>
                               <td>&lt'2020-01-01T12:00'</td>
                               <td>LESS THAN</td>
                             </tr>
                             <tr>
                               <td>expr1 expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 & expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 && expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 | expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                             <tr>
                               <td>expr1 || expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                           </table>`;
            }
            break;
        case AttributeTypeEnum.VALUE_LIST:
            this.eGui.innerHTML = `<table class="ag-grid-rule-tooltip">
                             <tr>
                               <th>EXPR</th>
                               <th>RULE</th>
                             </tr>
                             <tr>
                               <td>phrase</td>
                               <td>CONTAINS VALUE STARTING WITH</td>
                             </tr>
                             <tr>
                               <td>!phrase</td>
                               <td>DOESN'T CONTAIN VALUE STARTING WITH</td>
                             </tr>
                             <tr>
                               <td>phrase=</td>
                               <td>CONTAINS EXACT</td>
                             </tr>
                             <tr>
                               <td>!phrase=</td>
                               <td>DOES NOT CONTAIN EXACT</td>
                             </tr>
                             <tr>
                               <td>=</td>
                               <td>ANY VALUE</td>
                             </tr>
                             <tr>
                               <td>!=</td>
                               <td>NO VALUE</td>
                             </tr>
                             <tr>
                               <td>expr1 expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 & expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 && expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 | expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                             <tr>
                               <td>expr1 || expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                           </table>`;
            break;
        case AttributeTypeEnum.TAGS:
            this.eGui.innerHTML = `<table class="ag-grid-rule-tooltip">
                             <tr>
                               <th>EXPR</th>
                               <th>RULE</th>
                             </tr>
                             <tr>
                               <td>phrase</td>
                               <td>CONTAINS TAG STARTING WITH</td>
                             </tr>
                             <tr>
                               <td>!phrase</td>
                               <td>DOESN'T CONTAIN TAG STARTING WITH</td>
                             </tr>
                             <tr>
                               <td>phrase=</td>
                               <td>CONTAINS EXACT</td>
                             </tr>
                             <tr>
                               <td>!phrase=</td>
                               <td>DOES NOT CONTAIN EXACT</td>
                             </tr>
                             <tr>
                               <td>=</td>
                               <td>ANY VALUE</td>
                             </tr>
                             <tr>
                               <td>!=</td>
                               <td>NO VALUE</td>
                             </tr>
                             <tr>
                               <td>expr1 expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 & expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 && expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 | expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                             <tr>
                               <td>expr1 || expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                           </table>`;
            break;
        default:
            this.eGui.innerHTML = `<table class="ag-grid-rule-tooltip">
                             <tr>
                               <th>EXPR</th>
                               <th>RULE</th>
                             </tr>
                             <tr>
                               <td>phrase</td>
                               <td>STARTS WITH</td>
                             </tr>
                             <tr>
                               <td>!phrase</td>
                               <td>DOES NOT START WITH</td>
                             </tr>
                             <tr>
                               <td>phrase=</td>
                               <td>EQUALS</td>
                             </tr>
                             <tr>
                               <td>!phrase=</td>
                               <td>DOES NOT EQUAL</td>
                             </tr>
                              <tr>
                               <td>=</td>
                               <td>ANY VALUE</td>
                             </tr>
                             <tr>
                               <td>!=</td>
                               <td>NO VALUE</td>
                             </tr>
                             <tr>
                               <td>expr1 expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 & expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 && expr2</td>
                               <td>LOGICAL AND</td>
                             </tr>
                             <tr>
                               <td>expr1 | expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                             <tr>
                               <td>expr1 || expr2</td>
                               <td>LOGICAL OR</td>
                             </tr>
                           </table>`;
    }
};

AgHelpToolTip.prototype.getGui = function () {
    return this.eGui;
};

export const helpHeaderTemplate =
    '<div class="ag-cell-label-container" role="presentation">' +
    '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
    '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
    '    <i style="color: orange; margin-right: 2px" class="fas fa-question-circle fa-lg ag-help-question-mark"></i> ' +
    '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
    '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
    '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
    '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
    '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
    '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
    '  </div>' +
    '</div>';



// WEBPACK FOOTER //
// ./app/components/bo-core/common/AgHeaderHelpToolTip.ts